<app-logo-header></app-logo-header>
<div class="section bg-white">
  <div class="container">
    <h1>{{ 'FAQ.EasykashFaq' | translate }}</h1>

    <div class="my-3">
      <a class="btn btn-outline-danger me-3" href="faq#seller-section">{{ 'FAQ.SellersFaq' | translate }}</a>
      <a class="btn btn-outline-danger me-3" href="faq#buyer-section">{{ 'FAQ.BuyersFaq' | translate }}</a>
      <a class="btn btn-outline-danger" href="faq#support-section">{{ 'FAQ.Support' | translate }}</a>
    </div>

    <p>
      {{ 'FAQ.FaqDescription' | translate }}
    </p>

    <p>
      {{ 'FAQ.FaqNote' | translate }}
    </p>

    <h4 class="faq-section-title" id="seller-section" style="color: #31708f;">
      {{ 'FAQ.I' | translate }}
      <span class="fw-bold">
        {{ 'FAQ.Seller' | translate }}
      </span>
    </h4>

    <!-- begin::Questions -->
    <div class="accordion" id="accordionExample">
      <!-- QUESTION 1 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            {{ 'FAQ.Q01' | translate }}
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A01' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 2 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingTwo">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            {{ 'FAQ.Q02' | translate }}
          </button>
        </h2>
        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5>
                <span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span>
              </h5>
              <p>
                {{ 'FAQ.A02P01' | translate }}
              </p>

              <p>
                {{ 'FAQ.A02P02' | translate }}
              </p>

              <p>
                {{ 'FAQ.A02P03' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 3 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingThree">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
                  aria-expanded="false" aria-controls="collapseThree">
            {{ 'FAQ.Q03' | translate }}
          </button>
        </h2>
        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A03' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 4 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-4">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4"
                  aria-expanded="false" aria-controls="collapse-4">
            {{ 'FAQ.Q04' | translate }}
          </button>
        </h2>
        <div id="collapse-4" class="accordion-collapse collapse" aria-labelledby="heading-4" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A04' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 5 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-5">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-5"
                  aria-expanded="false" aria-controls="collapse-5">
            {{ 'FAQ.Q05' | translate }}
          </button>
        </h2>
        <div id="collapse-5" class="accordion-collapse collapse" aria-labelledby="heading-5" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ol style="list-style-type: decimal !important; margin-left: 20px;">
                <li>
                  {{ 'FAQ.A05L01' | translate }}
                </li>
                <li>{{ 'FAQ.A05L02' | translate }}</li>
                <li>{{ 'FAQ.A05L03' | translate }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 6 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-6">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-6"
                  aria-expanded="false" aria-controls="collapse-6">
            {{ 'FAQ.Q06' | translate }}
          </button>
        </h2>
        <div id="collapse-6" class="accordion-collapse collapse" aria-labelledby="heading-6" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A06' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 7 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-7">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-7"
                  aria-expanded="false" aria-controls="collapse-7">
            {{ 'FAQ.Q07' | translate }}
          </button>
        </h2>
        <div id="collapse-7" class="accordion-collapse collapse" aria-labelledby="heading-7" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A07' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 8 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-8">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-8"
                  aria-expanded="false" aria-controls="collapse-8">
            {{ 'FAQ.Q08' | translate }}
          </button>
        </h2>
        <div id="collapse-8" class="accordion-collapse collapse" aria-labelledby="heading-8" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ol style="list-style-type: decimal !important; margin-left: 20px;">
                <li>
                  {{ 'FAQ.A08L01' | translate }}
                </li>
                <li>{{ 'FAQ.A08L02' | translate }}</li>
                <li>{{ 'FAQ.A08L03' | translate }}</li>
                <li>{{ 'FAQ.A08L04' | translate }}</li>
                <li>{{ 'FAQ.A08L05' | translate }}</li>
                <li>{{ 'FAQ.A08L06' | translate }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 9 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-9">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-9"
                  aria-expanded="false" aria-controls="collapse-9">
            {{ 'FAQ.Q09' | translate }}
          </button>
        </h2>
        <div id="collapse-9" class="accordion-collapse collapse" aria-labelledby="heading-9" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A09' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 10 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-10">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-10"
                  aria-expanded="false" aria-controls="collapse-10">
            {{ 'FAQ.Q10' | translate }}
          </button>
        </h2>
        <div id="collapse-10" class="accordion-collapse collapse" aria-labelledby="heading-10" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ul style="list-style-type: circle !important; margin-left: 20px;">
                <li>{{ 'FAQ.A10L01' | translate }}</li>
                <li>{{ 'FAQ.A10L02' | translate }}</li>
                <li>{{ 'FAQ.A10L03' | translate }}</li>
                <li>{{ 'FAQ.A10L04' | translate }}</li>
                <li>{{ 'FAQ.A10L05' | translate }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 11 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-11">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-11"
                  aria-expanded="false" aria-controls="collapse-11">
            {{ 'FAQ.Q11' | translate }}
          </button>
        </h2>
        <div id="collapse-11" class="accordion-collapse collapse" aria-labelledby="heading-11" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>{{ 'FAQ.A11' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 12 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-12">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-12"
                  aria-expanded="false" aria-controls="collapse-12">
            {{ 'FAQ.Q12' | translate }}
          </button>
        </h2>
        <div id="collapse-12" class="accordion-collapse collapse" aria-labelledby="heading-12" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ol style="list-style-type: decimal !important; margin-left: 20px;">
                <li>
                  {{ 'FAQ.A12L01' | translate }}
                </li>
                <li>{{ 'FAQ.A12L02' | translate }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 13 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-13">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-13"
                  aria-expanded="false" aria-controls="collapse-13">
            {{ 'FAQ.Q13' | translate }}
          </button>
        </h2>
        <div id="collapse-13" class="accordion-collapse collapse" aria-labelledby="heading-13" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>{{ 'FAQ.A13' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 14 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-14">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-14"
                  aria-expanded="false" aria-controls="collapse-14">
            {{ 'FAQ.Q14' | translate }}
          </button>
        </h2>
        <div id="collapse-14" class="accordion-collapse collapse" aria-labelledby="heading-14" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ol style="list-style-type: decimal !important; margin-left: 20px;">
                <li>{{ 'FAQ.A14L01' | translate }}</li>
                <li>{{ 'FAQ.A14L02' | translate }}</li>
                <li>{{ 'FAQ.A14L03' | translate }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 15 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-15">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-15"
                  aria-expanded="false" aria-controls="collapse-15">
            {{ 'FAQ.Q15' | translate }}
          </button>
        </h2>
        <div id="collapse-15" class="accordion-collapse collapse" aria-labelledby="heading-15" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A15' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 16 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-16">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-16"
                  aria-expanded="false" aria-controls="collapse-16">
            {{ 'FAQ.Q16' | translate }}
          </button>
        </h2>
        <div id="collapse-16" class="accordion-collapse collapse" aria-labelledby="heading-16" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>{{ 'FAQ.A16P01' | translate }}</p>

              <h6>{{ 'FAQ.A16P02' | translate }}</h6>
              <ul style="list-style-type: circle !important; margin-left: 20px;">
                <li>{{ 'FAQ.A16L01' | translate }}</li>
                <li>{{ 'FAQ.A16L02' | translate }}</li>
                <li>{{ 'FAQ.A16L03' | translate }}</li>
                <li>
                  {{ 'FAQ.A16L04' | translate }}
                </li>
                <li>{{ 'FAQ.A16L05' | translate }}</li>
                <li>{{ 'FAQ.A16L06' | translate }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 17 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-17">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-17"
                  aria-expanded="false" aria-controls="collapse-17">
            {{ 'FAQ.Q17' | translate }}
          </button>
        </h2>
        <div id="collapse-17" class="accordion-collapse collapse" aria-labelledby="heading-17" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A17' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 18 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-18">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-18"
                  aria-expanded="false" aria-controls="collapse-18">
            {{ 'FAQ.Q18' | translate }}
          </button>
        </h2>
        <div id="collapse-18" class="accordion-collapse collapse" aria-labelledby="heading-18" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A18' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 19 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-19">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-19"
                  aria-expanded="false" aria-controls="collapse-19">
            {{ 'FAQ.Q19' | translate }}
          </button>
        </h2>
        <div id="collapse-19" class="accordion-collapse collapse" aria-labelledby="heading-19" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A19' | translate }}
              </p>
              <ul style="list-style-type: circle !important; margin-left: 20px;">
                <li>{{ 'FAQ.A19L01' | translate }}</li>
                <li>{{ 'FAQ.A19L02' | translate }}</li>
                <li>{{ 'FAQ.A19L03' | translate }}</li>
                <li>{{ 'FAQ.A19L04' | translate }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4 class="faq-section-title" id="buyer-section" style="color: #31708f;">
      <br />{{ 'FAQ.I' | translate }}
      <span class="font-weight-bold">{{ 'FAQ.Buyer' | translate }}</span>
    </h4>

    <div class="accordion" id="accordion-2">
      <!-- QUESTION 20 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-20">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-20"
                  aria-expanded="false" aria-controls="collapse-20">
            {{ 'FAQ.Q20' | translate }}
          </button>
        </h2>
        <div id="collapse-20" class="accordion-collapse collapse" aria-labelledby="heading-20" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A20' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 21 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-21">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-21"
                  aria-expanded="false" aria-controls="collapse-21">
            {{ 'FAQ.Q21' | translate }}
          </button>
        </h2>
        <div id="collapse-21" class="accordion-collapse collapse" aria-labelledby="heading-21" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A21' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 22 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-22">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-22"
                  aria-expanded="false" aria-controls="collapse-22">
            {{ 'FAQ.Q22' | translate }}
          </button>
        </h2>
        <div id="collapse-22" class="accordion-collapse collapse" aria-labelledby="heading-22" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ol style="list-style-type: decimal !important; margin-left: 20px;">
                <li>
                  {{ 'FAQ.A22L01' | translate }}
                </li>
                <li>{{ 'FAQ.A22L02' | translate }}</li>
                <li>{{ 'FAQ.A22L03' | translate }}</li>
                <li>{{ 'FAQ.A22L04' | translate }}</li>
                <li>{{ 'FAQ.A22L05' | translate }}</li>
                <li>{{ 'FAQ.A22L06' | translate }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 23 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-23">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-23"
                  aria-expanded="false" aria-controls="collapse-23">
            {{ 'FAQ.Q23' | translate }}
          </button>
        </h2>
        <div id="collapse-23" class="accordion-collapse collapse" aria-labelledby="heading-23" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <ol style="list-style-type: decimal !important; margin-left: 20px;">
                <li>
                  {{ 'FAQ.A23L01' | translate }}
                </li>
                <li>{{ 'FAQ.A23L02' | translate }}</li>
                <li>{{ 'FAQ.A23L03' | translate }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 24 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-24">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-24"
                  aria-expanded="false" aria-controls="collapse-24">
            {{ 'FAQ.Q24' | translate }}
          </button>
        </h2>
        <div id="collapse-24" class="accordion-collapse collapse" aria-labelledby="heading-24" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A24' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 25 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-25">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-25"
                  aria-expanded="false" aria-controls="collapse-25">
            {{ 'FAQ.Q25' | translate }}
          </button>
        </h2>
        <div id="collapse-25" class="accordion-collapse collapse" aria-labelledby="heading-25" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A25' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 26 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-26">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-26"
                  aria-expanded="false" aria-controls="collapse-26">
            {{ 'FAQ.Q26' | translate }}
          </button>
        </h2>
        <div id="collapse-26" class="accordion-collapse collapse" aria-labelledby="heading-26" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A26' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 27 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-27">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-27"
                  aria-expanded="false" aria-controls="collapse-27">
            {{ 'FAQ.Q27' | translate }}
          </button>
        </h2>
        <div id="collapse-27" class="accordion-collapse collapse" aria-labelledby="heading-27" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A27' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 28 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-28">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-28"
                  aria-expanded="false" aria-controls="collapse-28">
            {{ 'FAQ.Q28' | translate }}
          </button>
        </h2>
        <div id="collapse-28" class="accordion-collapse collapse" aria-labelledby="heading-28" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A28' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 29 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-29">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-29"
                  aria-expanded="false" aria-controls="collapse-29">
            {{ 'FAQ.Q29' | translate }}
          </button>
        </h2>
        <div id="collapse-29" class="accordion-collapse collapse" aria-labelledby="heading-29" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A29' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- QUESTION 30 -->
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading-30">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-30"
                  aria-expanded="false" aria-controls="collapse-30">
            {{ 'FAQ.Q30' | translate }}
          </button>
        </h2>
        <div id="collapse-30" class="accordion-collapse collapse" aria-labelledby="heading-30" data-bs-parent="#accordion-2">
          <div class="accordion-body">
            <div class="content">
              <h5><span class="label label-primary">{{ 'FAQ.Answer' | translate }}</span></h5>
              <p>
                {{ 'FAQ.A30' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4 class="faq-section-title" id="support-section" style="color: #31708f;">
      <br />
      <span class="font-weight-bold">{{ 'FAQ.DoYouNeedHelp' | translate }}</span>
    </h4>

    <div class="content">
      <h5>
        <span class="label label-primary">{{ 'Sellers.Dashboard.CustomerSupport' | translate }}:</span>
      </h5>
      <div class="p-2">
        <p>
          {{ 'Sellers.Dashboard.ContactCustomerSupport' | translate }}.
        </p>
        <div class="p-1">
        <div>{{ 'Sellers.Dashboard.Phone' | translate }}: <span class="text-secondary no-rtl">{{supportInfo.phone1}}  &nbsp;-&nbsp; {{supportInfo.phone}}</span>
        </div>
        <div>{{ 'Sellers.Dashboard.WorkingHours' | translate }}: <span
            class="text-secondary no-rtl">{{supportInfo.workingHours}}.</span></div>
      </div>
    </div>
    </div>


    <div class="mt-4 text-center">
      <h4>{{ 'FAQ.Ready' | translate }}</h4>
      <button class="btn btn-primary" routerLink="/signup">{{ 'FAQ.CreateAccount' | translate }}</button>
    </div>
  </div>

</div>

<app-footer></app-footer>
